/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{E72DD894-AF7B-46E0-839F-5BD00EAC4F8D}",
  "sitecoreApiHost": "https://jss.homeserve.co.uk",
  "jssAppName": "hs-living",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/sitecore/api/graph/edge",
  "graphQLEndpoint": "https://jss.homeserve.co.uk/sitecore/api/graph/edge"
};